<!-- Phone validation code entry view -->
<section class="form-group" [ngClass]="{ 'd-none': loading }">
  <article class="wrapper fadeInDown" id="formContent">
    <!-- ICON -->
    <nav class="fadeIn first">
      <img class="logo" src="../assets/muirwood-studio.png" />
    </nav>
    <div>
      <h3>{{ "validationCode" | translate }}</h3>
    </div>
    <!-- LOGIN FORM -->
    <form (ngSubmit)="ctx.phoneNumberValidate()">
      <div class="form-group fadeIn second">
        <!-- Input for validation code received by phone number -->
        <input
          id="phoneNumberValidation"
          type="text"
          [(ngModel)]="ctx.confirmationCode"
          class="form-control"
          name="phoneNumberValidation"
          placeholder="{{ 'validationCode' | translate }}"
          required
          autocomplete="off"
        />
      </div>
      <input
        type="submit"
        skipLocationChange
        class="fadeIn fourth"
        value="{{ 'validateCode' | translate }}"
        height="30px"
      />
    </form>
  </article>
</section>
